<!--  TANULÓI ADATLAP – lásd a .ts fejkommentjét. Minden, ami itt látszik, a kiszolgáló szerep
      szerinti válaszából jön: amit a kérdező nem láthat, az a válaszban sincs. -->
<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start"><ion-menu-button></ion-menu-button></ion-buttons>
    <ion-title>Tanulói adatlap</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
<div class="ta">

  <!-- ── Kereső: egyetlen mező, a kiszolgáló keres, lapozva ── -->
  <div class="ta-kereso" #keresoDoboz>
    <ion-searchbar placeholder="Tanuló neve, oktatási azonosítója vagy osztálya (pl. 9.b)…" [debounce]="300"
                   [value]="kereso" (ionInput)="keresValt($event.detail.value)" (ionFocus)="fokusz()"
                   (keydown)="billentyu($event)"></ion-searchbar>
    <div class="ta-lenyilo" *ngIf="nyitva" (scroll)="listaGorget($event)" role="listbox">
      <div class="ta-regi" *ngIf="admin">
        <ion-checkbox [(ngModel)]="regi" (ionChange)="regiValt()" labelPlacement="end">Korábbi tanévek tanulói is</ion-checkbox>
      </div>
      <button type="button" class="ta-talalat" *ngFor="let t of talalatok; let i = index" role="option"
              [class.kijelolt]="i === kijelolt" [class.valasztott]="tanulo?.oktazon === t.oktazon" (click)="valaszt(t)">
        <app-profilkep tipus="tanulo" [azon]="t.oktazon" [nev]="t.nev" [meret]="28"></app-profilkep>
        <span class="ta-talalat-nev">{{ t.nev }}<small *ngIf="!t.aktiv"> (kilépett)</small></span>
        <span class="ta-talalat-osztaly">{{ t.osztaly || '–' }}</span>
        <span class="ta-talalat-okt">{{ t.oktazon }}</span>
      </button>
      <div class="ta-lenyilo-jel" *ngIf="keresFut"><ion-spinner name="dots"></ion-spinner> Keresés…</div>
      <button type="button" class="ta-tovabb" *ngIf="!keresFut && tovabb" (click)="keres(false)">További tanulók…</button>
      <div class="ta-lenyilo-jel hiba" *ngIf="keresHiba">{{ keresHiba }}</div>
      <div class="ta-lenyilo-jel" *ngIf="!keresFut && !keresHiba && !talalatok.length">
        {{ kereso.trim() ? 'Nincs találat.' : 'Nincs megjeleníthető tanuló.' }}
        <span *ngIf="!admin"> A listában csak azok a tanulók vannak, akiket tanítasz, vagy akiknek az osztályfőnöke vagy.</span>
      </div>
    </div>
  </div>

  <!-- ── Még nincs kiválasztott tanuló ── -->
  <div class="ta-ures" *ngIf="!tanulo">
    <ion-icon name="id-card-outline"></ion-icon>
    <p>Kezdd el gépelni a tanuló nevét, oktatási azonosítóját vagy az osztályát, vagy kattints a mezőbe a névsorhoz.</p>
    <p class="ta-halvany">Az adatlap csak olvasható. A pedagógus azoknak a tanulóknak az adatlapját látja, akiket tanít,
      az osztályfőnök a saját osztályáét.</p>
  </div>

  <div class="ta-jelzo" *ngIf="adatFut"><ion-spinner name="crescent"></ion-spinner></div>
  <div class="ta-hiba" *ngIf="adatHiba"><ion-icon name="alert-circle-outline"></ion-icon>{{ adatHiba }}</div>

  <ng-container *ngIf="adat && !adatFut">
    <!-- ── Fejléc ── -->
    <div class="ta-fej">
      <app-profilkep tipus="tanulo" [azon]="t.oktazon" [nev]="t.nev" [meret]="64"></app-profilkep>
      <div class="ta-fej-szoveg">
        <h2>{{ t.nev }}</h2>
        <div class="ta-fej-sor">
          <b>{{ aktivJogviszony?.osztaly_nev || 'nincs osztálya' }}</b>
          <span *ngIf="aktivJogviszony?.evfolyam"> · {{ aktivJogviszony.evfolyam }}. évfolyam</span>
          <span> · {{ t.oktazon }}</span>
          <span *ngIf="t.szul_datum"> · szül. {{ t.szul_datum }}</span>
        </div>
        <div class="ta-chipek">
          <span class="ta-chip c-warning" *ngIf="adat.sni_btmn?.sni">SNI</span>
          <span class="ta-chip c-warning" *ngIf="adat.sni_btmn?.btmn">BTMN</span>
          <span class="ta-chip c-tertiary" *ngIf="egyeniMunkarendek.length">Egyéni munkarend</span>
          <span class="ta-chip" *ngIf="aktivJogviszony?.statusz == 2">Jogviszony szünetel</span>
          <span class="ta-chip" *ngIf="aktivJogviszony?.vege && aktivJogviszony.vege < ma">Kilépett ({{ aktivJogviszony.vege }})</span>
          <span class="ta-chip c-danger" *ngIf="minosit?.nem_minositheto">Mulasztás miatt nem minősíthető</span>
          <span class="ta-chip c-warning" *ngIf="!minosit?.nem_minositheto && minosit?.osszes_figyel">Mulasztás 200 óra fölött</span>
          <span class="ta-chip c-danger" *ngIf="minosit?.igazolatlan_megtagadhato">Igazolatlan 20 óra fölött</span>
          <span class="ta-chip" *ngIf="adat.felmentesek?.length">{{ adat.felmentesek.length }} felmentés</span>
          <span class="ta-chip" [class.c-success]="adat.kreta?.van">{{ adat.kreta?.van ? 'KRÉTA-tükörben megvan' : 'Nincs a KRÉTA-tükörben' }}</span>
        </div>
      </div>
      <span class="ta-szerep">{{ szerepSzoveg }}</span>
    </div>
    <div class="ta-rejtett" *ngIf="adat.jog?.rejtett?.length">
      <ion-icon name="lock-closed-outline"></ion-icon>
      <span>A szereped miatt nem látszik: {{ adat.jog.rejtett.join('; ') }}.</span>
    </div>

    <ion-segment class="ta-fulek" [scrollable]="true" [(ngModel)]="ful" (ionChange)="fulValt()">
      <ion-segment-button value="attekintes" layout="icon-start"><ion-icon name="person-outline"></ion-icon><ion-label>Áttekintés</ion-label></ion-segment-button>
      <ion-segment-button value="ellenorzo" layout="icon-start"><ion-icon name="school-outline"></ion-icon><ion-label>Ellenőrző</ion-label></ion-segment-button>
      <ion-segment-button value="csalad" layout="icon-start"><ion-icon name="people-outline"></ion-icon><ion-label>Gondviselők</ion-label></ion-segment-button>
      <ion-segment-button value="tamogatas" layout="icon-start"><ion-icon name="medkit-outline"></ion-icon><ion-label>Támogatás</ion-label></ion-segment-button>
      <ion-segment-button value="egyeb" layout="icon-start" *ngIf="egyebLathato"><ion-icon name="folder-open-outline"></ion-icon><ion-label>Fegyelmi, étkezés, iratok</ion-label></ion-segment-button>
    </ion-segment>

    <!-- ══ ÁTTEKINTÉS ══ -->
    <ng-container *ngIf="ful === 'attekintes'">
      <section class="ta-szakasz">
        <h3 class="ta-cim"><ion-icon name="person-outline"></ion-icon>Törzsadatok</h3>
        <dl class="ta-mezok">
          <ng-container *ngFor="let m of TORZS_MEZOK">
            <div class="ta-mezo" *ngIf="vanMezo(m.kulcs)"><dt>{{ m.cimke }}</dt><dd>{{ torzsErtek(m.kulcs) }}</dd></div>
          </ng-container>
        </dl>
      </section>

      <section class="ta-szakasz">
        <h3 class="ta-cim"><ion-icon name="ribbon-outline"></ion-icon>Jogviszony és osztály</h3>
        <div class="ta-halvany" *ngIf="!adat.jogviszony?.length">Nincs rögzített jogviszony.</div>
        <table class="ta-tabla" *ngIf="adat.jogviszony?.length">
          <thead><tr><th>Osztály</th><th>Kezdete</th><th>Várható vége</th><th>Vége</th><th>Állapot</th><th>Megjegyzés</th></tr></thead>
          <tbody>
            <tr *ngFor="let j of adat.jogviszony" [class.mult]="j.vege && j.vege < ma">
              <td data-cimke="Osztály"><b>{{ j.osztaly_nev || '–' }}</b><small *ngIf="j.evfolyam"> · {{ j.evfolyam }}. évf.</small></td>
              <td data-cimke="Kezdete">{{ j.kezdete || '–' }}</td>
              <td data-cimke="Várható vége">{{ j.varh_vege || '–' }}</td>
              <td data-cimke="Vége">{{ j.vege || 'folyamatban' }}</td>
              <td data-cimke="Állapot">{{ statuszNev(j.statusz) }}</td>
              <td data-cimke="Megjegyzés">
                <span *ngIf="j.vendeg == 1">vendégtanuló </span>
                <span *ngIf="j.ideiglenes == 1">ideiglenes </span>
                <span *ngIf="j.egyeni_tanrend">egyéni munkarend </span>
                <span *ngIf="j.naplosorszam">naplósorszám: {{ j.naplosorszam }} </span>
                <span *ngIf="j.kilepes_ok">· {{ j.kilepes_ok }}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 class="ta-alcim">Csoportok a tanévben</h4>
        <div class="ta-halvany" *ngIf="!adat.csoportok?.length">Nincs csoporttagság a tanévben.</div>
        <div class="ta-chipek">
          <span class="ta-chip" *ngFor="let c of adat.csoportok" [class.lezart]="c.vege && c.vege < ma"
                [title]="(c.kezdete || '…') + ' – ' + (c.vege || 'folyamatban')">
            {{ c.csoport }}<small *ngIf="c.vege && c.vege < ma"> (kilépett {{ c.vege }})</small>
          </span>
        </div>
      </section>

      <section class="ta-szakasz">
        <h3 class="ta-cim"><ion-icon name="time-outline"></ion-icon>Mulasztás és minősíthetőség</h3>
        <ng-container *ngIf="minosit && !minosit.hiba; else minositHiba">
          <div class="ta-szamok">
            <div class="ta-szam" [class.baj]="minosit.osszes > minosit.hatar?.OSSZES" [class.figy]="minosit.osszes > minosit.hatar?.OSSZES_FIGYEL"><b>{{ minosit.osszes }}</b><span>összes óra</span></div>
            <div class="ta-szam ok"><b>{{ minosit.igazolt }}</b><span>igazolt</span></div>
            <div class="ta-szam" [class.baj]="minosit.igazolatlan > minosit.hatar?.IGAZOLATLAN" [class.figy]="minosit.igazolatlan > 0"><b>{{ minosit.igazolatlan }}</b><span>igazolatlan</span></div>
            <div class="ta-szam" [class.figy]="minosit.elbiralatlan > 0"><b>{{ minosit.elbiralatlan }}</b><span>még elbírálatlan</span></div>
            <div class="ta-szam" *ngIf="minosit.keses_ora"><b>{{ minosit.keses_ora }}</b><span>késésből</span></div>
          </div>
          <div class="ta-allapot" [ngClass]="'c-' + minositSzoveg.szin">{{ minositSzoveg.szoveg }}</div>
          <table class="ta-tabla" *ngIf="minosit.tantargyak?.length">
            <thead><tr><th>Tantárgy</th><th class="jobb">Megtartott</th><th class="jobb">Mulasztott</th><th class="jobb">Igazolatlan</th><th class="jobb">Arány</th><th>Jelzés</th></tr></thead>
            <tbody>
              <tr *ngFor="let x of minosit.tantargyak">
                <td data-cimke="Tantárgy"><b>{{ x.tantargy || '–' }}</b></td>
                <td data-cimke="Megtartott" class="jobb">{{ x.megtartott }}<small *ngIf="x.tervezett"> / {{ x.tervezett }}</small></td>
                <td data-cimke="Mulasztott" class="jobb">{{ x.mulasztott }}</td>
                <td data-cimke="Igazolatlan" class="jobb">{{ x.igazolatlan }}</td>
                <td data-cimke="Arány" class="jobb">{{ x.szazalek }}%</td>
                <td data-cimke="Jelzés"><span class="ta-chip" [ngClass]="'c-' + szintSzin(x.szint)">{{ szintNev(x.szint) }}</span></td>
              </tr>
            </tbody>
          </table>
          <p class="ta-halvany">20/2012. EMMI r. 51. § (7)–(8): 250 óránál vagy egy tantárgyból a megtartott órák 30%-ánál több mulasztás esetén
            a tanuló nem minősíthető; 20 igazolatlan óra fölött az osztályozó vizsga megtagadható. A mulasztások napokra bontva az Ellenőrző fülön.</p>
        </ng-container>
        <ng-template #minositHiba><div class="ta-halvany">{{ minosit?.hiba || 'A tanévben nincs mulasztási adat.' }}</div></ng-template>
      </section>

      <section class="ta-szakasz">
        <h3 class="ta-cim"><ion-icon name="sync-outline"></ion-icon>KRÉTA-állapot</h3>
        <p *ngIf="adat.kreta?.van">A tanuló megvan a KRÉTA-tükörben
          <span *ngIf="adat.kreta.osztaly">(KRÉTA-osztály: {{ adat.kreta.osztaly }})</span>; az adatai utoljára {{ adat.kreta.letoltve || '–' }}-kor jöttek át.</p>
        <p *ngIf="!adat.kreta?.van">A tanuló nincs a KRÉTA-tükörben: a tanulói adatok KRÉTA-átvétele még nem hozta át (vagy a tanuló nincs a KRÉTÁ-ban).</p>
        <p class="ta-halvany" *ngIf="adat.sni_btmn?.frissitve">Az SNI/BTMN-adatok KRÉTA-szinkronja: {{ adat.sni_btmn.frissitve }}.</p>
      </section>
    </ng-container>

    <!-- ══ ELLENŐRZŐ (a meglévő komponens; csak az első megnyitáskor kerül a lapra) ══ -->
    <div class="ta-ellenorzo" *ngIf="ellenorzoNyitva" [hidden]="ful !== 'ellenorzo'">
      <app-tanulo-ellenorzo [oktazon]="t.oktazon" [intezmeny]="intezmeny" [nev]="t.nev"></app-tanulo-ellenorzo>
    </div>

    <!-- ══ GONDVISELŐK ══ -->
    <ng-container *ngIf="ful === 'csalad'">
      <section class="ta-szakasz">
        <h3 class="ta-cim"><ion-icon name="people-outline"></ion-icon>Szülők, gondviselők</h3>
        <div class="ta-halvany" *ngIf="!adat.gondviselok?.length">Nincs rögzített gondviselő.</div>
        <div class="ta-kartyak">
          <div class="ta-kartya" *ngFor="let g of adat.gondviselok">
            <div class="ta-kartya-fej"><b>{{ g.nev || '–' }}</b>
              <span class="ta-chip" *ngIf="g.torv_kepv">törvényes képviselő</span></div>
            <div class="ta-halvany">{{ g.rokonsag || 'gondviselő' }}</div>
            <div *ngIf="g.email"><ion-icon name="mail-outline"></ion-icon> <a [href]="'mailto:' + g.email">{{ g.email }}</a></div>
            <div *ngIf="g.telefon"><ion-icon name="call-outline"></ion-icon> <a [href]="'tel:' + g.telefon">{{ g.telefon }}</a></div>
            <div *ngIf="g.cim"><ion-icon name="home-outline"></ion-icon> {{ g.cim }}</div>
            <div *ngIf="g.tart_cim" class="ta-halvany">Tartózkodási hely: {{ g.tart_cim }}</div>
          </div>
        </div>
        <p class="ta-halvany" *ngIf="adat.jog?.szerep === 'tanar'">A gondviselőknek az Üzenetek menüben írhatsz (a tanuló osztályának vagy csoportjának szülői köre).</p>
      </section>
    </ng-container>

    <!-- ══ TÁMOGATÁS: SNI/BTMN, szakértői vélemény, felmentés, egyéni munkarend, gyermekvédelem ══ -->
    <ng-container *ngIf="ful === 'tamogatas'">
      <section class="ta-szakasz">
        <h3 class="ta-cim"><ion-icon name="medkit-outline"></ion-icon>SNI / BTMN</h3>
        <div class="ta-chipek">
          <span class="ta-chip" [class.c-warning]="adat.sni_btmn?.sni">Sajátos nevelési igényű: {{ adat.sni_btmn?.sni ? 'igen' : 'nem' }}</span>
          <span class="ta-chip" [class.c-warning]="adat.sni_btmn?.btmn">BTMN: {{ adat.sni_btmn?.btmn ? 'igen' : 'nem' }}</span>
        </div>
        <dl class="ta-mezok egyoszlop" *ngIf="adat.sni_btmn?.adatok?.length">
          <div class="ta-mezo" *ngFor="let a of adat.sni_btmn.adatok"><dt>{{ a.cimke }}</dt><dd class="ta-szoveg">{{ a.ertek }}</dd></div>
        </dl>
        <h4 class="ta-alcim" *ngIf="adat.szakertoi_velemenyek?.length">Szakértői vélemények</h4>
        <div class="ta-kartya" *ngFor="let v of adat.szakertoi_velemenyek">
          <div class="ta-kartya-fej"><b>{{ v.tipus || 'Szakértői vélemény' }}</b><span class="ta-halvany">kelt: {{ v.kelt || '–' }}</span></div>
          <div *ngIf="v.ervenyesseg">Érvényesség: {{ v.ervenyesseg }}</div>
          <div *ngIf="v.kovetkezo_felulvizsgalat">Következő felülvizsgálat: {{ v.kovetkezo_felulvizsgalat }}</div>
          <div *ngIf="v.fogyatekossag">Fogyatékosság: {{ v.fogyatekossag }}</div>
          <div *ngIf="v.bizottsag_nev" class="ta-halvany">{{ v.bizottsag_nev }}<span *ngIf="v.velemeny_szam"> · {{ v.velemeny_szam }}</span></div>
          <div *ngIf="v.javaslat" class="ta-szoveg"><b>Javaslat:</b> {{ v.javaslat }}</div>
          <div *ngIf="v.megjegyzes" class="ta-szoveg ta-halvany">{{ v.megjegyzes }}</div>
        </div>
      </section>

      <section class="ta-szakasz">
        <h3 class="ta-cim"><ion-icon name="shield-checkmark-outline"></ion-icon>Felmentések</h3>
        <div class="ta-halvany" *ngIf="!adat.felmentesek?.length">Nincs rögzített felmentés.</div>
        <table class="ta-tabla" *ngIf="adat.felmentesek?.length">
          <thead><tr><th>Tantárgy</th><th>Időszak</th><th>Mi alól</th><th>Ok / határozat</th><th>Forrás</th></tr></thead>
          <tbody>
            <tr *ngFor="let f of adat.felmentesek" [class.mult]="!felmentesEl(f)">
              <td data-cimke="Tantárgy"><b>{{ f.tantargy_nev || '–' }}</b></td>
              <td data-cimke="Időszak">{{ f.kezdete || '?' }} – {{ f.vege || 'visszavonásig' }}</td>
              <td data-cimke="Mi alól">{{ felmentesMiAlol(f) }}</td>
              <td data-cimke="Ok" class="ta-szoveg">{{ f.ok || '' }}<span *ngIf="f.hatarozat"> – {{ f.hatarozat }}</span></td>
              <td data-cimke="Forrás">{{ f.forras }}</td>
            </tr>
          </tbody>
        </table>
      </section>

      <section class="ta-szakasz">
        <h3 class="ta-cim"><ion-icon name="walk-outline"></ion-icon>Egyéni munkarend</h3>
        <div class="ta-halvany" *ngIf="!egyeniMunkarendek.length">Nincs egyéni munkarend.</div>
        <div *ngFor="let j of egyeniMunkarendek" class="ta-sor">
          <b>{{ j.egyeni_tanrend_kezdete || j.kezdete || '…' }} – {{ j.egyeni_tanrend_vege || j.vege || 'a jogviszony végéig' }}</b>
          <span *ngIf="j.osztaly_nev"> ({{ j.osztaly_nev }})</span>
          <div class="ta-halvany" *ngIf="j.egyeni_tanrend_oka">{{ j.egyeni_tanrend_oka }}</div>
        </div>
        <p class="ta-halvany" *ngIf="egyeniMunkarendek.length">Az időszakában hiányzás nem rögzíthető, jegyet csak osztályozó vizsgából kaphat.</p>
      </section>

      <section class="ta-szakasz" *ngIf="adat.helyzet !== null">
        <h3 class="ta-cim"><ion-icon name="heart-outline"></ion-icon>Hátrányos helyzet, gyermekvédelem</h3>
        <div class="ta-halvany" *ngIf="!adat.helyzet?.length">Nincs rögzített hátrányos helyzet vagy gyermekvédelmi adat.</div>
        <table class="ta-tabla" *ngIf="adat.helyzet?.length">
          <thead><tr><th>Helyzet</th><th>Időszak</th><th *ngIf="adat.jog?.admin">Határozat</th><th *ngIf="adat.jog?.admin">Megjegyzés</th></tr></thead>
          <tbody>
            <tr *ngFor="let h of adat.helyzet" [class.mult]="h.vege && h.vege < ma">
              <td data-cimke="Helyzet"><b>{{ h.nev }}</b></td>
              <td data-cimke="Időszak">{{ h.kezdete || '…' }} – {{ h.vege || '…' }}</td>
              <td data-cimke="Határozat" *ngIf="adat.jog?.admin">{{ h.hatarozat || '–' }}</td>
              <td data-cimke="Megjegyzés" *ngIf="adat.jog?.admin">{{ h.megjegyzes || '' }}</td>
            </tr>
          </tbody>
        </table>
      </section>
    </ng-container>

    <!-- ══ FEGYELMI, ÉTKEZÉS, IRATOK (admin és osztályfőnök) ══ -->
    <ng-container *ngIf="ful === 'egyeb'">
      <section class="ta-szakasz" *ngIf="adat.fegyelmi !== null">
        <h3 class="ta-cim"><ion-icon name="shield-outline"></ion-icon>Fegyelmi eljárások</h3>
        <div class="ta-halvany" *ngIf="!adat.fegyelmi?.length">Nincs fegyelmi eljárás.</div>
        <div class="ta-kartya" *ngFor="let f of adat.fegyelmi">
          <div class="ta-kartya-fej"><b>{{ f.ugyszam || 'Fegyelmi eljárás' }}</b><span class="ta-chip">{{ f.allapot_nev }}</span></div>
          <div class="ta-szoveg" *ngIf="f.kotelessegszeges">{{ f.kotelessegszeges }}</div>
          <div class="ta-halvany">
            <span *ngIf="f.kotelessegszeges_napja">kötelességszegés: {{ f.kotelessegszeges_napja }}</span>
            <span *ngIf="f.meginditas_napja"> · megindítva: {{ f.meginditas_napja }}</span>
            <span *ngIf="f.hatarozat_napja"> · határozat: {{ f.hatarozat_napja }}</span>
            <span *ngIf="f.vegleges_napja"> · végleges: {{ f.vegleges_napja }}</span>
          </div>
          <div *ngIf="f.buntetes || f.dontes">Döntés: {{ f.buntetes || f.dontes }}</div>
        </div>
      </section>

      <section class="ta-szakasz" *ngIf="adat.etkezes">
        <h3 class="ta-cim"><ion-icon name="restaurant-outline"></ion-icon>Étkezés</h3>
        <div class="ta-chipek">
          <span class="ta-chip" [class.c-success]="adat.etkezes.etkezik">{{ adat.etkezes.etkezik ? 'Étkezik' : 'Nem étkezik' }}</span>
          <span class="ta-chip c-warning" *ngIf="adat.etkezes.laktozmentes">laktózmentes</span>
          <span class="ta-chip c-warning" *ngIf="adat.etkezes.glutenmentes">gluténmentes</span>
          <span class="ta-chip" *ngIf="adat.etkezes.kedvezmeny_szazalek">{{ adat.etkezes.kedvezmeny_szazalek }}% kedvezmény</span>
        </div>
        <dl class="ta-mezok">
          <div class="ta-mezo"><dt>Étkezőhely</dt><dd>{{ adat.etkezes.hely || '–' }}</dd></div>
          <div class="ta-mezo"><dt>Megrendelt napok ebben a hónapban</dt><dd>{{ adat.etkezes.havi_napok }}</dd></div>
          <div class="ta-mezo"><dt>Megrendelt napok a tanévben</dt><dd>{{ adat.etkezes.tanevi_napok }}</dd></div>
          <div class="ta-mezo"><dt>Következő megrendelt nap</dt><dd>{{ adat.etkezes.kovetkezo || '–' }}</dd></div>
        </dl>
      </section>

      <section class="ta-szakasz" *ngIf="adat.dokumentumok !== null">
        <h3 class="ta-cim"><ion-icon name="document-text-outline"></ion-icon>Kiállított dokumentumok</h3>
        <div class="ta-halvany" *ngIf="!adat.dokumentumok?.length">Nincs kiállított dokumentum (digitális bizonyítvány, okirat).</div>
        <table class="ta-tabla" *ngIf="adat.dokumentumok?.length">
          <thead><tr><th>Kelt</th><th>Típus</th><th>Megnevezés</th><th>Állapot</th></tr></thead>
          <tbody>
            <tr *ngFor="let d of adat.dokumentumok" [class.mult]="d.ervenytelen">
              <td data-cimke="Kelt">{{ d.letrehozva || '–' }}</td>
              <td data-cimke="Típus">{{ dokTipus(d.tipus) }}</td>
              <td data-cimke="Megnevezés"><b>{{ d.nev || '–' }}</b></td>
              <td data-cimke="Állapot">{{ d.ervenytelen ? 'érvénytelenítve' : (d.alairt ? 'aláírva' : 'aláíratlan') }}</td>
            </tr>
          </tbody>
        </table>
        <p class="ta-halvany">A dokumentumok letöltése és kiállítása: Adminisztráció › Dokumentumok.</p>
      </section>
    </ng-container>
  </ng-container>
</div>
</ion-content>
